export var extractLinkParam = function (name, link) {
    var match = RegExp("[?&]" + name + "=([^&]*)").exec(link);
    return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : undefined;
};
export var removeLinkParams = function (link) {
    return link ? link.split('?')[0] : undefined;
};
export var removeLastSlash = function (link) {
    return link === null || link === void 0 ? void 0 : link.replace(/\/$/, '');
};
